import { render, staticRenderFns } from "./NoveltyItem.vue?vue&type=template&id=6e80f276&scoped=true&"
import script from "./NoveltyItem.vue?vue&type=script&lang=ts&"
export * from "./NoveltyItem.vue?vue&type=script&lang=ts&"
import style0 from "./NoveltyItem.vue?vue&type=style&index=0&id=6e80f276&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e80f276",
  null
  
)

export default component.exports